import * as stylex from "@stylexjs/stylex";
import { colors, radii, spacing } from "@softmax/design-system/tokens.stylex";

export const styles = stylex.create({
  carousel: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space8,
    containerType: "inline-size",
  },
  frame: {
    position: "relative",
    aspectRatio: {
      default: "16 / 9",
      "@container (max-width: 639px)": "1 / 1",
    },
    width: "100%",
    minHeight: 0,
    overflow: "clip",
    borderRadius: radii.medium,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    outline: {
      default: "none",
      ":focus-visible": `2px solid ${colors.foreground}`,
    },
    outlineOffset: 3,
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    backgroundColor: colors.surfaceAlt,
  },
  // Opt-in (`landscape`): 16:9 at every width.
  landscape: { aspectRatio: "16 / 9" },
  // Opt-in with it: an odd aspect (a tall board capture) shows whole on a
  // paper backdrop, never cropped or stretched.
  screenReader: {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
});
